import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, computed, ref, onMounted, toRaw } from 'vue'
import { useRoute } from 'vue-router'
import { Modal as AModal } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import ClueAssign from '../components/ClueAssign.vue'
import { clueTypeEnum } from '../dataConfig'
import { genderEnum, linkRoleTypeEnum } from '@/views/overseasSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { infoData } from '@/api/overseasSales/followRuleSetting'
import { publicClueList, publicClueCollect, salesClueDetail } from '@/api/overseasSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { FbuPublicClueParams, FbuPublicClueListItem } from '@/typings/api/clueManage'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuPublicClue' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const route = useRoute()

// 线索类型枚举列表
const clueTypeEnumComputed = computed(() => clueTypeEnum.filter((item) => item.value !== 0))
const paramCodeData: {
  [key: string]: ParamCodeItem[]
} = reactive({
  ofbu_follow_purpose: [], // 拜访目的
  ofbu_follow_mode: [] // 拜访方式（跟进方式）
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_follow_purpose', 'ofbu_follow_mode']
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}
const clueRuleList = ref<string[]>([])
const getFollowRuleInfo = async () => {
  const { data } = await infoData({ appId: 'cos_ofbu', configType: 3 })
  clueRuleList.value = (data as any).CLUE_RULE_2.split(',')
}
onMounted(() => {
  getFollowRuleInfo()
  getByParamCodes()
})

// 获取详情联系人信息
const showMask = (record: FbuPublicClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId as string }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}

const tableRef = ref()
const queryForm = reactive<FbuPublicClueParams>({ contact: { type: 1 } })

const columns = computed(() => [
  {
    title: t('clue.customerName'),
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/ofbu/salesClue/view',
    query: ['clueId', 'isPublicClue=1', `returnPath=${route.fullPath}`],
    fixed: 'left',
    width: 200
  },
  { title: t('clue.clueId'), dataIndex: 'clueId', width: 200 },
  { title: t('clue.channel'), dataIndex: 'channel' },
  { title: t('clue.clueType'), dataIndex: 'clueType', dicData: clueTypeEnum },
  { title: t('clue.customerRegion'), dataIndex: 'customerRegion' },
  { title: t('clue.beforeFollowerName'), dataIndex: 'beforeFollowerName' },
  { title: t('clue.followDesc'), dataIndex: 'followDesc' },
  { title: t('common.contactName'), dataIndex: ['contact', 'name'], cosType: 'mask' },
  { title: t('common.mobile'), dataIndex: ['contact', 'mobile'], cosType: 'mask' },
  { title: t('common.skype'), dataIndex: ['contact', 'skype'], cosType: 'mask' },
  { title: t('common.email'), dataIndex: ['contact', 'email'], cosType: 'mask' },
  { title: t('common.sex'), dataIndex: ['contact', 'sex'], dicData: genderEnum },
  { title: t('common.jobRole'), dataIndex: ['contact', 'jobRole'], dicData: linkRoleTypeEnum },
  { title: t('common.createTime'), dataIndex: 'createTime', width: 190 },
  { title: t('clue.firstReceiveTime'), dataIndex: 'firstReceiveTime', width: 190 },
  { title: t('clue.lastReceiveTime'), dataIndex: 'lastReceiveTime', width: 190 },
  { title: t('clue.firstFollowerName'), dataIndex: 'firstFollowerName' },
  { title: t('clue.lastFollowerName'), dataIndex: 'lastFollowerName' },
  { title: t('clue.transferToPubilcTime'), dataIndex: 'transferTime', width: 190 },
  { title: t('common.remark'), dataIndex: 'remark' },
  {
    title: t('common.action'),
    dataIndex: 'action',
    langWidth: {
      zh: 180,
      en: 260
    },
    fixed: 'right'
  }
])
const getList = (queryForm: FbuPublicClueParams, callBack: (res: any) => void) => {
  publicClueList(queryForm).then((res) => {
    callBack(res)
  })
}
const handleQueryChange = (type: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}

const selectedData = ref<FbuPublicClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: FbuPublicClueListItem[]) => {
  selectedData.value = selectedRows
}

// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) return message.warning(t('clue.selectClaimClue'))
  const data = row ? [row] : toRaw(selectedData.value)
  clueAssignRef.value?.init(data)
}
// 领取线索
const handleReceive = (row?: FbuPublicClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.warning(t('clue.selectDrawClue'))
  }
  const clueIdList: any[] = []
  if (row) {
    clueIdList.push(row.clueId)
  } else {
    selectedData.value.forEach((item) => {
      clueIdList.push(item.clueId)
    })
  }
  AModal.confirm({
    title: t('clue.isSueDrawClue'),
    content: t('clue.returnClueRuleTitle', {
      day: clueRuleList.value[0]
    }),
    okText: t('btn.receive'),
    onOk() {
      publicClueCollect({ clueIdList }).then(() => {
        message.success(t('tips.drawSuccess'))
        handleQueryChange('fetch')
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel() {}
  })
}

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { "is-breadcrumb": true }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              rowKey: "clueId",
              "row-selection": { onChange: onSelectRowsChange },
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[13] || (_cache[13] = ($event: any) => ((queryForm) = $event)),
              onFetch: getList,
              onMask: showMask,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "DcCosOFbuPublicClue"
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.clueType')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosSelect, {
                          value: queryForm.clueTypeList,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.clueTypeList) = $event)),
                          options: clueTypeEnumComputed.value,
                          placeholder: _unref(t)('common.pleaseSelect'),
                          allowClear: "",
                          mode: "multiple",
                          "max-tag-count": "responsive",
                          "show-arrow": ""
                        }, null, 8, ["value", "options", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.customerName')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.customerName,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.customerName) = $event)),
                          valueModifiers: { trim: true },
                          maxlength: 100,
                          allowClear: "",
                          placeholder: _unref(t)('common.pleaseInput')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.channel')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(ParamCodeCascader, {
                              type: "search",
                              ids: queryForm.channelList,
                              "onUpdate:ids": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.channelList) = $event)),
                              appId: "cos_ofbu",
                              paramCode: "ofbu_source_channel",
                              style: {"width":"33%"}
                            }, null, 8, ["ids"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.channelExplain,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.channelExplain) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: _unref(t)('common.pleaseInput'),
                              allowClear: ""
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('common.createTime')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CosRangePicker, {
                          isOutputBeijingTime: "",
                          startTime: queryForm.startCreateTime,
                          "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.startCreateTime) = $event)),
                          endTime: queryForm.endCreateTime,
                          "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.endCreateTime) = $event))
                        }, null, 8, ["startTime", "endTime"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('common.contactMethod')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: queryForm.contact.type,
                              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.contact.type) = $event)),
                              style: {"width":"33%"},
                              placeholder: _unref(t)('common.pleaseSelect')
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('common.mobile')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('common.email')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 3 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)('common.skype')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value", "placeholder"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.contact.keyword,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.contact.keyword) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: _unref(t)('common.pleaseInput')
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.customerRegion')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_ofbu",
                          ids: queryForm.customerRegionList,
                          "onUpdate:ids": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.customerRegionList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.beforeFollower')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserSelect, {
                          value: queryForm.beforeFollower,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.beforeFollower) = $event)),
                          placeholder: _unref(t)('common.pleaseSelect'),
                          allowClear: ""
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_dc_form_item, {
                      label: _unref(t)('clue.clueId')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.clueId,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.clueId) = $event)),
                          maxlength: 100,
                          allowClear: "",
                          placeholder: _unref(t)('common.pleaseInput')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (handleAssignPerson()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.assignClue')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_public_clue_assign_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (handleReceive()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.receiveClue')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'ofbu_public_clue_receive_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                  appId: "cos_ofbu",
                  taskType: "402",
                  search: queryForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('btn.export')), 1)
                  ]),
                  _: 1
                }, 8, ["search"])), [
                  [_directive_permission, 'ofbu_public_clue_export_btn']
                ])
              ]),
              bodyCell: _withCtx(({ column, record, text }) => [
                (column.dataIndex === 'channel')
                  ? (_openBlock(), _createBlock(ChannelText, {
                      key: 0,
                      appId: "cos_ofbu",
                      paramCode: "ofbu_source_channel",
                      value: text,
                      desc: record.channelExplain
                    }, null, 8, ["value", "desc"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'customerRegion')
                  ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                      key: 1,
                      appId: "cos_ofbu",
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleAssignPerson(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.assignClue')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_public_clue_assign_btn']
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (handleReceive(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('btn.receiveClue')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'ofbu_public_clue_receive_btn']
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["row-selection", "columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ClueAssign, {
      ref_key: "clueAssignRef",
      ref: clueAssignRef,
      onFetch: _cache[14] || (_cache[14] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512)
  ], 64))
}
}

})